if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initializeRecommendations();
      }

      initializeRecommendations() {
        if (!this.innerHTML.trim().length) {
          this.loadRecommendations(true);
        }
      }

      loadRecommendations(complementary) {
        let url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}${
          complementary ? '&intent=complementary' : ''
        }`;

        if (!complementary) url = url.replace('limit=2', 'limit=1');

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('cart-recommendations');
            if (recommendations?.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            } else {
              this.loadRecommendations(false);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
